module.exports = __webpack_public_path__ + "img/next_h.cd53cf9.png";